import { Box, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Grid } from '@mui/material'
import type { Monitor, MonitorCreateViewResource } from 'shared/types'
import { DateTime } from 'luxon'
import styles from './MarketSpySection.module.css'
import { useReadMonitorByIdQuery } from 'services/monitor'
import { MarketSpyContainer } from './containers/MarketSpyContainer'

interface MarketSpySectionProps{
    marketSpyId?: number
}

export const MarketSpySection = (props: MarketSpySectionProps): JSX.Element => {
    const {
        marketSpyId
    } = props

    return (
        <>
            <Accordion disableGutters>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: '#FFF' }} />}
                    aria-controls="panel1a-content"
                    sx={{
                        backgroundColor: '#FFF',
                        flexDirection: 'row-reverse',
                        padding: {
                            xs: '8px 12px', md: '8px 24px'
                        },
                        '& .MuiAccordionSummary-expandIconWrapper': {
                            padding: '12px 12px 12px 12px',
                            fill: '#717171',
                            color: '#717171'
                        },

                        '& .MuiSvgIcon-root': {
                            fill: '#717171',
                            color: '#717171'
                        },
          
                        '& .MuiAccordionSummary-content': {
                            flexDirection: {
                                xs: 'column',
                                sm: 'row'
                            }
                        },
             
                    }}
                >
                    <Typography sx={
                        {
                            fontSize: {
                                xs: '24px',
                                sm: '24px',
                                md: '24px',
                            }, 
                            lineHeight: '28px',
                            color: '#000',
                            fontWeight: 600,
                            marginRight: 2
                        }
                    }
                    >Spy</Typography>
                    
                </AccordionSummary>
                <AccordionDetails sx={{ bgcolor: '#EEE', p: 0 }}>
                    <MarketSpyContainer
                        marketSpyId={marketSpyId}
                    />
                </AccordionDetails>
            </Accordion>
        </>  
     
    )
}
